import { useRef } from 'react'
import { Callback } from 'Src/types/utilTypes'
import { useEffectOnce } from '../useEffectOnce'

export const useUnmount = (cleanFn: Callback<void, void>) => {
	const funcRef = useRef(cleanFn)

	funcRef.current = cleanFn

	useEffectOnce(() => () => funcRef.current())
}
